import gql from 'graphql-tag'

export const GENERATE_PUBLIC_API_KEY = gql`
  mutation GeneratePublicApiKey {
    generatePublicApiKey {
      isSuccessful
      message
      publicApiKey {
        publicApiKey
      }
    }
  }
`
export const GET_COMPANY_INPUT = gql`
  query Company($filter: GetCompanyInput) {
  company(filter: $filter) {
    isSuccessful
    message
    company {
      id
      idleTimeout
      parkTimeout
      offlineTimeout
      fuelGainAlert
      fuelLossAlert
      isActive
      showGeocode
      name
      domainName
      logoUrl
      email
      phoneNo
      faxNo
      taxNo
      category
      publicApiKey
      publicApiTokenExpiry
      companyTag
      dsBase
      dsIntervalType
      dsInitialInterval
      dsInitialBonus
      dsInterval
      dsBonus
      dsCostBrake
      dsCostAccel
      dsCostOverspeed
      dsCostSharpturn
      dsMinScoreA
      dsMinScoreB
      dsMinScoreC
      dsMinScoreD
      vsms1Customer
      bankAccounts {
        bankAccountId
        companyId
        bankName
        accountName
        accountNo
        isDefault
      }
    }
  }
}
`
export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      isSuccessful
      message
      company {
        id
        idleTimeout
        parkTimeout
        offlineTimeout
        fuelGainAlert
        fuelLossAlert
        isActive
        showGeocode
        name
        domainName
        logoUrl
        email
        phoneNo
        faxNo
        taxNo
        category
        publicApiKey
        publicApiTokenExpiry
        companyTag
        dsBase
        dsIntervalType
        dsInitialInterval
        dsInitialBonus
        dsInterval
        dsBonus
        dsCostBrake
        dsCostAccel
        dsCostOverspeed
        dsCostSharpturn
        dsMinScoreA
        dsMinScoreB
        dsMinScoreC
        dsMinScoreD
        vsms1Customer
        bankAccounts {
          bankAccountId
          companyId
          bankName
          accountName
          accountNo
          isDefault
        }
      }
    }
  }
`
